import ClipboardJS from "clipboard";

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    beforeSend: function (jqXHR) {

    },
    error: function (event, status, error) {
        if (event.status === 403 || event.status === 419 || event.status === 401 || event.status === 404) {
            location.reload();
        }
    },
    complete: function (event, request, settings) {
        if (event.status === 403 || event.status === 419 || event.status === 401 || event.status === 404) {
            location.reload();
        }
    }
});
$(function () {
    const clipboard = new ClipboardJS('.btn');

    clipboard.on('success', function (e) {
        $(e.trigger).text('Copied!');

        setTimeout(function () {
            $(e.trigger).text('Copy');
        }, 2000);

        // setTooltip('Copied!');
        // hideTooltip();
        // $('.btn').tooltip('show')
    });
    $('input[name="search"]')
        .flexdatalist({
            searchContain: true,
            url: '/member/search',
            searchIn: ['text', 'extra_search'],
            iconProperty: 'thumb',
            visibleProperties: ['thumb', 'label', 'type', 'extra_visible'],
            cache: false,
            minLength: 1
        }).on('select:flexdatalist', function (_, selected, __) {
        window.location.href = selected.url;
    });


    $('body').on('change', '#invoice', function () {
        $('.form-element.timologio').hide();
        $('.form-element.timologio input').val('');
        $('.make-it-required').each(function () {
            $(this).attr('placeholder', $(this).attr('placeholder').replace(/\*/g, ''));
        })
        if ($(this).val() == 0) {
            $('.form-element.timologio').show();
            $('.make-it-required').each(function () {
                $(this).attr('placeholder', '*' + $(this).attr('placeholder'));
            })
        }
    });

    $('input[type=radio][name=derivative]').change(function () {
        $('[data-availability="1"]').hide();
        $('[data-availability="0"]').hide();
        $('[data-availability="' + this.value + '"]').show();
    });

    // Scroll to letter
    $('.letter').click(function () {
        if (!$(this).hasClass('disabled'))
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.group-' + $(this).data('index') + '-' + $(this).text().trim()).offset().top - 100
            }, 20);

        return false;
    });

    $('.lists').on('click', '.pagination-link', function (ev) {
        const self = $(this),
            url = self.attr('href');

        $('.loader').remove();
        $.ajax({
            url: url,
            data: {},
            beforeSend: function () {
                self.closest('.resault-wrapper').prepend('<div class="loader"></div>')
            },
            success: function (html) {
                self.closest('.resault-wrapper').html(html);
            },
            error: function () {
                $('.loader').remove();
            }
        })
        return false;
    });

    // Supplements all
    $('.indication').click(function () {
        $('.indication.active').removeClass('active');
        $('.supplements.active').removeClass('active');
        const id = $(this).data('indication');

        $(this).addClass('active');
        $(".supplements[data-indication='" + id + "']").addClass('active');
    })

    // ΑΛΛΗΛΕΠΙΔΡΑΣΕΙΣ ΦΑΡΜΑΚΩΝ
    let sortBy = 'per-ousia',
        // priority = ['_danger_filter', '_warning_filter', '_normal_filter'];
        priority = [];
    $('.rows').each(function () {
        priority.push(['_danger_filter', '_warning_filter', '_normal_filter'])
    });
    $('input.sort-by').change(function () {
        $('.' + $(this).data('hide')).hide();
        $('.' + this.value).show();
        sortBy = this.value;
    });

    $('input[type=checkbox][name=priority]').change(function () {
        const index = $(this).data('index');
        if (this.value === 'all') {
            priority[index] = ['_danger_filter', '_warning_filter', '_normal_filter'];
            $('input[type=checkbox][name=priority][data-index="' + index + '"][value="_danger_filter"]').prop('checked', false);
            $('input[type=checkbox][name=priority][data-index="' + index + '"][value="_warning_filter"]').prop('checked', false);
            $('input[type=checkbox][name=priority][data-index="' + index + '"][value="_normal_filter"]').prop('checked', false);
        } else {
            if ($('input[type=checkbox][name=priority][data-index="' + index + '"][value="all"]').prop('checked') === true) {
                priority[index] = [];
            }
            $('input[type=checkbox][name=priority][data-index="' + index + '"][value="all"]').prop('checked', false);
            if ($(this).prop('checked') === true) {
                if (!priority[index].includes(this.value)) {
                    priority[index].push(this.value)
                }
            }

            if ($(this).prop('checked') === false) {
                if (priority[index].includes(this.value)) {
                    const idx = priority[index].indexOf(this.value);
                    if (idx !== -1) {
                        priority[index].splice(idx, 1);
                    }
                }
            }
        }

        $('.wrapper-' + index).find('._danger_filter, ._warning_filter, ._normal_filter').removeClass('visible').hide()
        priority[index].forEach(function (priorityClass) {
            $('.wrapper-' + index).find('.' + priorityClass).addClass('visible').show();
        })

        alilepidraseisHideShowPerOusia(index);
        alilepidraseisHideShowAlphabet('per-ousia-' + index)

        alilepidraseisHideShowPerDrug(index);
        alilepidraseisHideShowAlphabet('per-drug-' + index)
    });

    function alilepidraseisHideShowPerOusia(index) {
        $('.per-ousia-' + index + ' .letter-group').each(function () {
            const self = $(this),
                letter = self.data('letter'),
                total = self.find('li').length,
                hidden = self.find('li:not(.visible)').length;

            if (total === hidden) {
                $('.per-ousia-' + index + ' .group-' + letter).removeClass('visible').hide();
            } else {
                $('.per-ousia-' + index + ' .group-' + letter).addClass('visible').show();
            }
        });
    }

    function alilepidraseisHideShowPerDrug(index) {
        $('.per-drug-' + index + ' .letter-group').each(function () {
            const self = $(this);
            self.find('li').each(function () {
                const liSelf = $(this),
                    spanTotal = liSelf.find('.svg-fix').length,
                    spanHidden = liSelf.find('.svg-fix:not(.visible)').length;

                if (spanTotal === spanHidden) {
                    liSelf.removeClass('visible').hide();
                } else {
                    liSelf.addClass('visible').show();
                }
            });

            const letter = self.data('letter'),
                total = self.find('li').length,
                hidden = self.find('li:not(.visible)').length;

            if (total === hidden) {
                $('.per-drug-' + index + ' .group-' + letter).removeClass('visible').hide();
            } else {
                $('.per-drug-' + index + ' .group-' + letter).addClass('visible').show();
            }
        });
    }

    function alilepidraseisHideShowAlphabet(group) {
        $('.' + group + ' .letter-group').each(function () {
            const self = $(this);
            if (self.hasClass('visible')) {
                $('.' + group + ' .letter-' + self.data('letter')).removeClass('disabled');
            } else {
                $('.' + group + ' .letter-' + self.data('letter')).addClass('disabled');
            }
        });
    }

    let selectedPack = '';
    showPack($('[data-pack="'+$('.pricing-plans-page').data('selected-plan')+'"]').eq(0), $('.pricing-plans-page').data('selected-plan'));

    $('body').on('click', '.form-trigger, .pack-option', function () {
        $('#pricing-plans').find('#back-btn').click();
        let pack = $(this).data('pack');
        showPack($(this), pack);
        // add the pack in the url as a query string
        let url = new URL(window.location.href);
        url.searchParams.set('pack', pack.replace('form-trigger-', ''));
        window.history.pushState({}, '', url);
        // selectedPack = pack;

    })

    function showPack(packOption, pack) {
        if (pack === '') {
            return;
        }

        if (!['form-trigger-trial', 'form-trigger-basic', 'form-trigger-plus'].includes(pack)) {
            return;
        }

        if (pack === 'form-trigger-trial') {
            $('#invoice').hide().val(1).trigger('change');
            $('#fname').css('max-width', '100%');
            $('#name-invoice').removeClass('flex-row');
        } else {
            $('#fname').css('max-width', '398px');
            $('#name-invoice').addClass('flex-row');
            $('#invoice').val(0).trigger('change').show();
        }

        $('.benefits-wrapper').hide();

        $('.desktop-view').addClass('form-open')
        $('.desktop-view').removeClass('details-open')
        $('.registration-form-wrapper').show()
        // There is a naming connection between trigger-btn and opening-container - checked input
        if (!packOption.hasClass('pack-option')) {
            $('.registration-form-wrapper .' + pack).trigger('click');
        }
    }


    $('#dashboard-load-stripe').click(function () {
        const self = $(this);
        $.ajax({
            url: self.data('hx-get'),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                self.closest('#payment-form').replaceWith($(html).find('#payment-form'));
                $('.loader-screen').hide();
            },
            error: function () {
                $('.loader-screen').hide();
            }
        })
    });

    $('.members-block__info__wrap, #pricing-plans').on('click', '#validate-invoice',function (e) {
        const self = $(this);

        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: $('#invoice-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                $('#invoice-values').replaceWith(html);
                document.getElementById('submit-stripe').click();
                // $('.loader-screen').hide();
            },
            error: function (err) {
                $('#invoice-values').replaceWith(err.responseText);
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    $('.members-block__info__wrap, #pricing-plans').on('click', '#validate-coupon',function (e) {
        const self = $(this);

        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: $('#invoice-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                document.getElementById('apply-coupon').click();
                // $('.loader-screen').hide();
            },
            error: function (err) {
                self.closest('form').find('#coupon-error').replaceWith(err.responseText);
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    $('.members-block__info__wrap, #pricing-plans').on('click', '#apply-coupon',function (e) {
        const self = $(this);
        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: $('#invoice-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                self.closest('#stripe-form-wrapper').replaceWith(html);
                $('.loader-screen').hide();
            },
            error: function (err) {
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    $('.members-block__info__wrap, #pricing-plans').on('click', '#cancel-subscription',function (e) {
        const self = $(this);
        $.ajax({
            url: self.data('hx-get'),
            data: $('#invoice-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                // refresh the page
                location.reload();
            },
            error: function (err) {
                $('#error').replaceWith(err.responseText);
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    $('#member-form').on('click', '#save-member',function (e) {
        const self = $(this);
        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: $('#member-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                self.closest('#edit-member').replaceWith($(html).find('#edit-member'));
                $('.loader-screen').hide();
            },
            error: function (err) {
                self.closest('#edit-member').replaceWith($(err.responseText).find('#edit-member'));
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    // PRICING PLANS
    $('#all-form').on('click', '#register',function (e) {
        const self = $(this);

        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: self.closest('#all-form').find('#register-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                if (html.redirect_to) {
                    window.location.href = html.redirect_to;
                    return;
                }
                self.closest('#register-form').replaceWith($(html).find('#register-form'));
                $('.loader-screen').hide();
            },
            error: function (err) {
                self.closest('#register-form').replaceWith($(err.responseText).find('#register-form'));
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });

    $('#pricing-plans').on('click', '#validate-customer',function (e) {
        const self = $(this);
        $.ajax({
            method: 'POST',
            url: self.data('hx-post'),
            data: self.closest('#all-form').find('#register-form').serialize(),
            beforeSend: function () {
                $('.loader-screen').show();
            },
            success: function (html) {
                if (html.redirect_to) {
                    window.location.href = html.redirect_to;
                    return;
                }
                self.closest('#all-form').replaceWith($(html).find('#all-form'));
                $('.loader-screen').hide();
            },
            error: function (err) {
                self.closest('#all-form').replaceWith($(err.responseText).find('#all-form'));
                $('.loader-screen').hide();
            }
        });

        e.preventDefault();
    });
});
